import { actionCreatorFactory } from "typescript-fsa";

const factory = actionCreatorFactory("MODULF");

export const generateArchivalContent = factory<{ activityId: string }>("ELDORADO_GENERATE_ARCHIVE");

export const sendArchiveToEldorado = factory<EldoradoSendArchivePayload>("ELDORADO_SEND_ARCHIVE");
export interface EldoradoSendArchivePayload {
	/**
	 * The Aktenkennzeichen of the prozess.
	 */
	readonly aktenkennzeichen: string;

	/**
	 * The Mappennummer of the prozess.
	 */
	readonly mappenNummer?: string;

	/**
	 * The betreff of the eldorado prozess.
	 */
	readonly betreff?: string;

	/**
	 * The absender of the eldorado prozess.
	 */
	readonly absender?: string;

	/**
	 * The bezug of the eldorado prozess.
	 */
	readonly bezug?: string;

	/**
	 * The dokumenten Art of the eldorado prozess.
	 */
	readonly dokumentenArt?: string;

	/**
	 * The papierform of the eldorado prozess.
	 */
	readonly papierform?: string;

	/**
	 * The UUID of the conversion job
	 */
	readonly jobUuid: string;

	/**
	 * The ID of the archival dialog activity to report back to
	 */
	readonly activityId: string;
}

export const cancelArchival = factory<EldoradoCancelArchivePayload>("ELDORADO_CANCEL");
export interface EldoradoCancelArchivePayload {
	readonly archiveSystem?: "eldorado" | "xakte";

	/**
	 * Flag for closing activity.
	 */
	readonly closeActivity: boolean;

	/**
	 * Flag for need of user confirmation.
	 * If true then the user must confirm the cancellation.
	 */
	readonly implicit?: boolean;

	/**
	 * The document reference of the relating document.
	 */
	readonly documentReference?: string;

	/**
	 * The ID of the archival dialog activity to report back to, if any.
	 */
	readonly activityId?: string;

	readonly reopenWorkflowsActivities?: boolean;
}
